import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Paper, Skeleton, Card } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Bar } from 'react-chartjs-2';
import axios from "axios";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { authState, popupState } from "../../Recoil/RecoilState";
import { baseURL } from "../../utils/StaticVariables";
import DesBtn from "../Reusable/DesBtn";
import OrderFilter from "./OrderFilter";

const commonOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'top', labels: { color: 'gray' } },
    title: { display: false }
  },
  scales: {
    x: { ticks: { color: 'gray' } },
    y: { ticks: { color: 'gray' } }
  }
};

const ModelConfidenceChart = () => {
  const [modelData, setModelData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { token } = useRecoilValue(authState);
  const setPopup = useSetRecoilState(popupState);
  const childRef = useRef(null);
  const [filter, setFilter] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const params = { ...filter };
        if (params.locations) { params.location = params.locations; delete params.locations; }
        if (params.buildings) { params.building = params.buildings; delete params.buildings; }
        if (params.zones) { params.zone = params.zones; delete params.zones; }

        const { data } = await axios.get(`${baseURL}shoplifting/dashboard/model-accuracy`, {
          headers: { Authorization: `Bearer ${token}` },
          params
        });
        setModelData(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    if (token) fetchData();
  }, [filter, token]);

  const openFilter = () => {
    setPopup({
      isOpen: true,
      title: "Select Date, Time and Location Filters",
      content: (
        <OrderFilter ref={childRef} filter={filter} changeFilterHandle={setFilter} />
      ),
      sendReq: () => childRef.current?.submit(),
    });
  };

  const average_per_camera = modelData?.average_per_camera || [];
  const cameraLabels = average_per_camera.map(item => item.camera_name  || 'Unknown');
  const confidenceData = average_per_camera.map(item => item.avg_confidence.toFixed(2)  || 0);

  return (
    <Card sx={{ p: 2, height: 'auto', bgcolor: 'background.paper', mb: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
         <Typography variant="h6">Model Accuracy & Confidence</Typography>
         <DesBtn text="Filter" handle={openFilter}>
          <FilterAltOutlinedIcon />
         </DesBtn>
      </Box>

      {loading || !modelData ? (
        <Skeleton variant="rectangular" height="400px" sx={{ borderRadius: 2 }} />
      ) : (
        <Paper elevation={0} sx={{ p: 2, height: 450, bgcolor: 'background.paper' }}>
          <Typography variant="subtitle1" mb={2}>Average Confidence Score per Camera Over All Incidents</Typography>
          <Box sx={{ height: 380 }}>
            <Bar 
              data={{
                labels: cameraLabels.length ? cameraLabels : ['No Data'],
                datasets: [{ label: 'Avg Confidence Score', data: confidenceData.length ? confidenceData : [0], backgroundColor: '#36a2eb' }]
              }}
              options={{
                ...commonOptions, 
                scales: { 
                  ...commonOptions.scales, 
                  y: { ...commonOptions.scales?.y, min: 0, max: 1 } 
                }
              }}
            />
          </Box>
        </Paper>
      )}
    </Card>
  );
};

export default ModelConfidenceChart;
